import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../../components/ColumnChooser';
import ExcelExportMenu from '../../../../../components/ExcelExportMenu';
import TableConstantActions from '../../../../../components/TableConstantActions';
import { ExcelExportMode } from '../../../../../helpers/excelExportRequest';
import { ColumnChooserModel } from '../../../../../models/common/ColumnChooserModel';
import { RootState } from '../../../../../redux/store';
import { HgsListIstegi } from '../../../../../services/HgsOgsService';
import { MenuComponent } from '../../../../../_metronic/assets/ts/components';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: HgsListIstegi
    setFilter: React.Dispatch<React.SetStateAction<HgsListIstegi>>
    selectedCount: number
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
    iceAktar: () => void
}

/** HGS liste araç çubuğu: arama (sefer no), güncelle / sil, kolon seçici, Excel, içe aktar (örnek Excel pencerede), yeni kayıt. */
const HgsOgsListFilters = ({ columns, setColumns, getColumns, pageName, pageVersion, excelExport, filter, setFilter, selectedCount, deleteFunction, updateFunction, onSearchSubmit, iceAktar }: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)
    const ekleyebilir = !!auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert;

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <TableConstantActions
                hideSearch
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            <ColumnChooser columns={columns} getColumns={getColumns} pageName={pageName} pageVersion={pageVersion} setColumns={setColumns} />

            <ExcelExportMenu pageName={pageName} selectedCount={selectedCount} onExport={excelExport} />

            {
                ekleyebilir && (
                    <button onClick={iceAktar} className='btn btn-sm btn-flex btn-light-success'>
                        <i className='fa fa-file-import fs-6 me-1' />
                        Excel'den içe aktar
                    </button>
                )
            }

            {
                ekleyebilir && (
                    <div className='m-0'>
                        <a onClick={() => navigate('/hgsogs/listadd')} className='btn btn-sm fw-bold btn-primary'>Yeni Kayıt Ekle</a>
                    </div>
                )
            }
        </React.Fragment>
    )
}

export default HgsOgsListFilters;
